import { render } from "./Toolbar2.vue?vue&type=template&id=6fda5cc0&ts=true"
import script from "./Toolbar2.vue?vue&type=script&lang=ts"
export * from "./Toolbar2.vue?vue&type=script&lang=ts"

import "./Toolbar2.vue?vue&type=style&index=0&id=6fda5cc0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__